import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";
import utils from "../utils/Utils";
import axios from 'axios';
import config from '../config';
import LayoutBlank from '../layout/LayoutBlank';
import Form from '../components/Form';
import PageLogo from '../components/PageLogo';
import PageTitle from '../components/PageTitle';
import FormField from '../components/FormField';
import PasswordHints from '../components/PasswordHints';
import ButtonSubmit from '../components/ButtonSubmit';
import { toast } from 'react-toastify';

export default function ResetPassword({ setCurrentPage }) {
    const { user, setUser, logoutUser } = useUser();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying');
    const [loading, setLoading] = useState(false);
    const [hints, setHints] = useState([]);
    
    useEffect(() => {
        const checkToken = async () => {
            const token = searchParams.get('token');
            // console.log(token);

            if (!token) {
                setStatus('error');
                toast.error('Invalid reset link, please request to resend link');

                setCurrentPage('forgotPassword');
                setTimeout(() => navigate('/forgot-password'), 3000);
            } else {
                setStatus('');
            }
        };

        logoutUser();
        checkToken();
    }, [searchParams, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value.trim(),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (user.new_password === '') {
            toast.info('Please enter your New Password')
            return;
        }

        // console.log(user.new_password);
        setHints([]);
        const hints = utils.validatePassword(user.new_password);
        if (hints?.length > 0) {
            setHints(hints);
            return;
        }

        // console.log(user.confirm_password);
        if (user.new_password !== user.confirm_password) {
            toast.error('New Password and Confirm Password must be the same')
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${config.apiBaseUrl}/auth/reset-password`, {
                token: searchParams.get('token'),
                new_password: user.new_password,
            });

            if (response.status === 200) {
                toast.success('Password reset successfully');
                toast.info('Redirecting to login');

                setCurrentPage('login');
                setTimeout(() => navigate('/'), 3000);
            }
 
        } catch (err) {
            toast.error('An error occurred. Please try again.');
        
        } finally {
            setLoading(false);
        }
    };

    return (
        <LayoutBlank>
            {status !== ''
            ?
                <div className="mt-8 p-6 bg-gray-800 rounded-lg shadow-md text-center">
                    {status === 'verifying' && (
                        <div>
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-300 mx-auto mb-4"></div>
                            <p className="text-orange-300">Verifying your request...</p>
                        </div>
                    )}

                    {status === 'error' && (
                        <div>
                            <h2 className="text-2xl font-bold text-orange-300 mb-2">Reset Password Failed</h2>
                            <p className="text-sm text-orange-200 mt-4">Redirecting to reset ...</p>
                        </div>
                    )}
                </div>
            :
                <Form handleSubmit={handleSubmit}>
                    <PageLogo />
                    <PageTitle pageTitle={"Reset Password"} />
                    <p className="mt-2 text-center text-sm text-orange-200">
                        Pleaee enter a new password
                    </p>
                    
                    <FormField
                        label={"New Password"}
                        name={"new_password"}
                        type={"password"}
                        value={user.new_password}
                        autoComplete="new-password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoFocus={true}
                    />

                    <FormField
                        label={"Confirm Password"}
                        name={"confirm_password"}
                        type={"password"}
                        value={user.confirm_password}
                        autoComplete="current-password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />

                    <PasswordHints hints={hints} />

                    <ButtonSubmit 
                        loading={loading} 
                        labeling={'Resetting ...'} 
                        label={'Reset Password'} 
                        disabled={loading}
                    />

                    <div className="mt-4 text-gray-200 text-center">
                        Or, resend the link?{" "}
                        <button
                            key='forgotPassword'
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrentPage('forgotPassword');
                                navigate('/');                                    
                            }}
                            className="text-orange-300 hover:underline"
                        >
                            Forgot Password
                        </button>
                    </div>

                    <div className="mt-4 text-gray-200 text-center">
                        Or, try to login again?{" "}
                        <button
                            key='forgotPassword'
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrentPage('login');
                                navigate('/');                                    
                            }}
                            className="text-orange-300 hover:underline"
                        >
                            Login
                        </button>
                    </div>
                </Form>
            }
        </LayoutBlank>
    );
}

